<script setup lang="ts">

definePageMeta({
  layout: 'auth',
  mode: 'login',
  title: 'Каталог офферов и партнерских программ PRM Online',
})

useHead({
  title: 'Каталог офферов и партнерских программ PRM Online',
  meta: [
    {
      name: 'title',
      content: 'Маркет PRM Online — Каталог CPA-офферов и партнёрских программ'
    },
    {
      property: 'og:title',
      content: 'Маркет PRM Online — Каталог CPA-офферов и партнёрских программ'
    },
    {
      name: 'twitter:title',
      content: 'Маркет PRM Online — Каталог CPA-офферов и партнёрских программ'
    },
    {
      name: 'description',
      content: 'Каталог проверенных партнёрских программ для вебмастеров, блогеров и маркетологов. SaaS, EdTech, ecommerce, юридические услуги — более 40 белых офферов. Монетизируйте трафик легально.'
    }
  ]
})

const authForm = ref()
const isDivider = ref(false)
watch(() => [authForm.value?.step, authForm.value?.currentTab], () => {
  isDivider.value = !(/*authForm.value?.currentTab === 'register' &&*/ authForm.value?.step === 'default')
})
</script>

<template>
  <div class="login-page">
    <div class="login-page-wrapper">
      <div class="login-page-offer-exchange-mobile">
        <auth-layout-advertisement :is-divider="isDivider"/>
      </div>
      <auth-layout-auth-form ref="authForm"/>
      <div class="login-page-offer-exchange-desktop">
        <auth-layout-advertisement />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

.login-page {
  display: flex;
  width: 100%;
  margin-top: clamp(2.5rem, 3vw, 3.75rem);

  @media (min-width: 960px) {
    align-items: center;
  }
}

.login-page-wrapper {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: clamp(3.25rem, 8vw, 6.25rem);

  @media (max-width: 959px) {
    flex-direction: column;
  }

  @media (min-width: 1960px) {
    justify-content: center;
  }
}

.login-page-offer-exchange-mobile {
  display: flex;
  padding: 0 5vw;

  @media (min-width: 960px) {
    display: none;
  }
}

.login-page-offer-exchange-desktop {
  display: flex;
  margin-right: 5vw;

  @media (max-width: 959px) {
    display: none;
  }
}

</style>
